import { useListContext } from 'react-admin';
import { useDatagridAGEditController, } from './useDatagridAGEditController';
import { useDatagridAGSelectionController, } from './useDatagridAGSelectionController';
import { useDatagridAGGridController, } from './useDatagridAGGridController';
export var useDatagridAGController = function (props) {
    var _a = useListContext(props), data = _a.data, isLoading = _a.isLoading;
    var rowData = (data !== null && data !== void 0 ? data : isLoading) ? data : [];
    // row selection logic
    var _b = useDatagridAGSelectionController(props), selectedIds = _b.selectedIds, onSelectionChanged = _b.onSelectionChanged, onFirstDataRendered = _b.onFirstDataRendered;
    // row editing logic
    var _c = useDatagridAGEditController(props), onRowEditingStarted = _c.onRowEditingStarted, onRowEditingStopped = _c.onRowEditingStopped, onCellEditRequest = _c.onCellEditRequest;
    var _d = useDatagridAGGridController(props), onStateUpdated = _d.onStateUpdated, onGridPreDestroyed = _d.onGridPreDestroyed, initialState = _d.initialState;
    return {
        rowData: rowData,
        selectedIds: selectedIds,
        onSelectionChanged: onSelectionChanged,
        onFirstDataRendered: onFirstDataRendered,
        onRowEditingStarted: onRowEditingStarted,
        onRowEditingStopped: onRowEditingStopped,
        onCellEditRequest: onCellEditRequest,
        onStateUpdated: onStateUpdated,
        onGridPreDestroyed: onGridPreDestroyed,
        initialState: initialState,
    };
};
